import React from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import { useModalStore } from "@/store/modle";
import colorfulLoading from "@/assets/images/colorfulLoading.svg";
import close from "@/assets/images/close.svg";
import { useDataStore } from "@/store/dataStore";
import { getChainInfoById } from "@/constants/const";
import { targetChainId } from "./StakeModal";

export default function WithdrawWaitingModal({ txHash }: { txHash: string }) {
  const setShowWithdrawWaitingModal = useModalStore(
    (state) => state.setShowWithdrawWaitingModal
  );
  const showWithdrawWaitingModal = useModalStore(
    (state) => state.showWithdrawWaitingModal
  );
  const { setRefreshData } = useDataStore((state) => state);

  return (
    <Modal
      closable
      open={showWithdrawWaitingModal}
      width={460}
      centered
      destroyOnHidden
      title={null}
      onCancel={() => {
        setRefreshData();
        setShowWithdrawWaitingModal(false);
      }}
      footer={null}
      maskClosable={false}
      className={styles.commonModal}
      closeIcon={<img src={close} alt="logo" width={24} height={24} />}
    >
      <div
        className={styles.checkingMotion}
        style={{ marginTop: 12, marginBottom: 20 }}
      >
        <div className={styles.checkingMotionThumb}></div>
      </div>
      <div className={styles.commonDes}>Withdrawing your stakes…</div>
      <div className={styles.commonDes2}>Please wait.</div>
      <div
        className={styles.commonLink}
        onClick={() => {
          window.open(
            getChainInfoById(targetChainId).blockExplorerUrl + "/tx/" + txHash,
            "_blank"
          );
        }}
      >
        View in explorer
      </div>
    </Modal>
  );
}
